import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import { z } from 'zod';

const endpoint = 'api/llm-usage/org-billing-summary/';
const url = apiUrl + endpoint;

const orgLlmBillingLimitsSchema = z.object({
  trial_credit_usd: z.number(),
  paid_included_cost_usd: z.number().nullable(),
  paid_included_tokens: z.number().nullable(),
});

export const orgLlmBillingSummarySchema = z.object({
  OrganizationUUID: z.string(),
  is_paid: z.boolean(),
  total_cost_usd: z.number(),
  input_tokens: z.number(),
  output_tokens: z.number(),
  total_tokens: z.number(),
  limits: orgLlmBillingLimitsSchema,
  active_cost_cap_usd: z.number().nullable(),
  active_token_cap: z.number().nullable(),
  remaining_included_cost_usd: z.number().nullable(),
  cost_overage: z.boolean(),
  token_overage: z.boolean(),
  has_overage: z.boolean(),
});

export type OrgLlmBillingLimits = z.infer<typeof orgLlmBillingLimitsSchema>;
export type OrgLlmBillingSummary = z.infer<typeof orgLlmBillingSummarySchema>;

export async function getOrgLlmBillingSummary(
  organizationUUID: string
): Promise<OrgLlmBillingSummary> {
  const res = await postWithAuth(url, {
    OrganizationUUID: organizationUUID,
  });

  if (!res.ok) {
    const errBody = await res.text();
    throw new Error(
      `getOrgLlmBillingSummary failed: ${res.status} ${errBody.slice(0, 200)}`
    );
  }

  const raw: unknown = await res.json();
  return orgLlmBillingSummarySchema.parse(raw);
}
